export default __webpack_public_path__ + "static/media/RemoveCuvetteLid.d78d62ac.svg";